import React, { useState } from 'react';
import { Chip, TableCell, TableRow } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { SerialNumber } from 'api/Responses/SetSerialNumberResponses';
import Button from 'components/Button';
import { useLanguage } from 'context/AppContext';
import Routes from 'routes';
import EditSerialNumberModal from './EditSerialNumberModal';

interface SerialNumberListItemProps {
  serialNumber: SerialNumber;
  setUUID: string;
  setCode: string;
  updateStateInParentComponent: (refresh: boolean) => void;
}

const SerialNumberListItem: React.FC<SerialNumberListItemProps> = ({
  serialNumber,
  setUUID,
  setCode,
  updateStateInParentComponent,
}) => {
  const [language] = useLanguage();
  const navigate = useNavigate();
  const [editSetModalOpen, setEditSetModalOpen] = useState<boolean>(false);

  const closeEditModal = () => {
    setEditSetModalOpen(false);
    updateStateInParentComponent(true);
  };

  return (
    <TableRow key={`${serialNumber.set_uss_id}`}>
      <TableCell align="center">{serialNumber.set_uss_value}</TableCell>
      <TableCell align="center">{serialNumber.location}</TableCell>
      <TableCell align="center">
        {serialNumber.active ? (
          <Chip variant="outlined" label="Active" color="success" />
        ) : (
          <Chip variant="outlined" label="Inactive" color="error" />
        )}
      </TableCell>
      <TableCell align="center">
        <Button onClick={() => setEditSetModalOpen(true)}>{language.ManageSerialNumbers.edit}</Button>
        <Button
          style={{ marginLeft: '10px' }}
          onClick={() => navigate(Routes.SerialNumberHistory.makePath(setCode, serialNumber.set_uss_id))}
        >
          {language.ManageSerialNumbers.history}
        </Button>
        {/* TODO: add in deactivate functionality later - disbled for MVP */}
        {/* <Button style={{ marginLeft: '10px' }}>Deactivate</Button> */}
      </TableCell>
      <EditSerialNumberModal
        serialNumberInitial={serialNumber.set_uss_value}
        open={editSetModalOpen}
        close={closeEditModal}
        setUUID={setUUID}
        setSerialId={serialNumber.set_uss_id}
      />
    </TableRow>
  );
};

export default SerialNumberListItem;
